import {
  getPhotohawkEnv,
  hasEnvOverride,
  setPhotohawkEnv,
  clearEnvOverride,
} from "@/lib/env";

/**
 * Tiny fixed badge shown ONLY when an explicit environment override is active
 * (set via `?phEnv=staging`), so normal production users never see it. Lets a
 * tester see which backend they're hitting and switch/reset (reloads on change).
 */
const EnvBadge = () => {
  if (!hasEnvOverride()) return null;
  const env = getPhotohawkEnv();
  const staging = env === "staging";

  return (
    <div className="fixed bottom-3 left-3 z-[100] flex items-center gap-2 rounded-full border border-border bg-background/95 backdrop-blur-sm px-3 py-1.5 shadow-md text-xs">
      <span
        className={`h-2 w-2 rounded-full ${staging ? "bg-amber-500" : "bg-green-500"}`}
      />
      <span className="font-semibold uppercase tracking-wide">
        {staging ? "Staging" : "Prod"}
      </span>
      {/* Only offer switch-to-prod. On prod we hide the switch entirely so the
          staging site doesn't invite jumping back to the staging backend. */}
      {staging && (
        <button
          className="text-primary hover:underline"
          onClick={() => setPhotohawkEnv("prod")}
        >
          switch to prod
        </button>
      )}
      <button className="text-muted-foreground hover:underline" onClick={clearEnvOverride}>
        reset
      </button>
    </div>
  );
};

export default EnvBadge;
